<template>
  <div>
    <v-card @click="openCalculator()" flat class="pa-0 ma-0">
      <v-row align="center" justify="center" class="pa-0 ma-0 vetalfa-row">
        <v-icon size="24" color="primary">{{ _icon("calculatorBtn") }}</v-icon>
      </v-row>
    </v-card>
    <vetalfa-calculator></vetalfa-calculator>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import Calculator from "@/components/Calculator.vue";
import functions from "@/router/functions.js";
export default {
  name: "CalculatorButton",
  components: { "vetalfa-calculator": Calculator },
  computed: {
    ...mapState("general", ["calculatorModel"]),
  },
  props: {},
  methods: {
    ...mapMutations("general", ["setCalculatorModel"]),
    ...mapActions("general", ["logEvent"]),
    openCalculator() {
      this.logEvent("open_calculator");
      this.setCalculatorModel(true);
    },
  },
  data() {
    return {};
  },
  watch: {
    calculatorModel(val) {
      functions.handlePageZoom({
        meta: { allowZoom: !!val ? !val : this.$route.meta.allowZoom },
      });
    },
  },
};
</script>